import React, { useEffect, useState } from "react";
import { Button, Col, Layout, message, Row, Spin, Switch } from "antd";
import AceEditor from "react-ace";
import firebase from "firebase";
import axios from "axios";
import "./view.scss";
import "./device-frame.scss";

import "ace-builds/src-noconflict/mode-xml";
import "ace-builds/src-noconflict/mode-html";
import "ace-builds/src-noconflict/mode-json";
import "ace-builds/src-noconflict/theme-xcode";

import beautify from "js-beautify";
import { useParams } from "react-router-dom";

export const CreativeViewPage: React.FC = () => {
  const { '*': targetPath } = useParams<{ '*': string }>();

  const [itemPath, setItemPath] = useState<string | undefined>(undefined);
  const [itemData, setItemData] = useState<string | undefined>(undefined);
  const [updatedData, setUpdatedData] = useState<string | undefined>(undefined);
  const [isSaving, setSaving] = useState(false);
  const [isDeviceLandscape, setDeviceLandscape] = useState(false);

  if (targetPath !== itemPath) {
    setItemPath(targetPath);
  }

  const handleSave = async () => {
    const newData: string | undefined = updatedData;
    if (newData && itemData !== newData) {
      setSaving(true);
      firebase
        .storage()
        .ref(targetPath)
        .putString(newData)
        .then(() => {
          setItemData(newData);
          message.success("Saved");
          setSaving(false);
        })
        .catch((e) => {
          message.error(e);
          setSaving(false);
        });
    }
  };

  useEffect(() => {
    firebase
      .storage()
      .ref(targetPath)
      .getDownloadURL()
      .then((downloadURL) => {
        return axios.get(downloadURL);
      })
      .then((response) => {
        const result = targetPath?.endsWith("html")
            ? beautify.html(response.data)
            : targetPath?.endsWith("xml")
                ? beautify.html(response.data)
                : beautify.js(response.data);
        setItemData(result);
      })
  }, [targetPath]);

  return (
    <>
      {!itemData ? (
        <Spin
          spinning={true}
          style={{ height: "100%", width: "100%", minHeight: "120px" }}
        />
      ) : (
        <Layout style={{ height: "100%", overflow: "hidden" }}>
          <Layout.Content>
            <Row gutter={[16, 0]} style={{ height: "100%" }}>
              <Col span={14} style={{ height: "100%" }}>
                <div>
                  <Button
                    loading={isSaving}
                    onClick={handleSave}
                    style={{ marginBottom: "16px" }}
                    disabled={!updatedData || updatedData === itemData}
                  >
                    Save
                  </Button>
                </div>
                <div>
                  <AceEditor
                    mode={
                      targetPath?.endsWith("json")
                        ? "json"
                        : targetPath?.endsWith("xml")
                        ? "xml"
                        : "html"
                    }
                    theme="xcode"
                    height={"90vh"}
                    width={"100%"}
                    value={updatedData ?? itemData}
                    onChange={(data: string) => setUpdatedData(data)}
                  />
                </div>
              </Col>
              <Col span={10} style={{ height: "100%" }}>
                <div style={{ display: "flex", justifyContent: "flex-end" }}>
                  <Switch
                    onChange={setDeviceLandscape}
                    checked={isDeviceLandscape}
                    checkedChildren={"Landscape"}
                    unCheckedChildren={"Portrait"}
                  />
                </div>
                <div className={"creative-info-page-wrapper"}>
                  <div
                    id="dev"
                    className={
                      "device device-black " +
                      (isDeviceLandscape ? "device-landscape" : "")
                    }
                  >
                    <iframe srcDoc={updatedData ?? itemData ?? ""} />
                  </div>
                </div>
              </Col>
            </Row>
          </Layout.Content>
        </Layout>
      )}
    </>
  );
};
